if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      // connectedCallback() {
      //   this.addEventListener('change', (event) => {
      //     const target = this.getInputForEventTarget(event.target);
      //     this.updateSelectedSwatchValue(event);
      //     FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
      //       data: {
      //         event,
      //         target,
      //         selectedOptionValues: this.selectedOptionValues,
      //       },
      //     });
      //   });
      // }

connectedCallback() {
  this.addEventListener('change', (event) => {
    if (event.target.matches('fieldset input[type="radio"]')) {
      this.autoPickAvailable(event.target);
    }
    const target = this.getInputForEventTarget(event.target);
    this.updateSelectedSwatchValue(event);
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event,
        target,
        selectedOptionValues: this.selectedOptionValues,
      },
    });
  });
}

autoPickAvailable(input) {
  const script = this.querySelector('script[data-variants]');
  if (!script) return;
  const variants = JSON.parse(script.textContent);
  const fieldsets = [...this.querySelectorAll('fieldset')];
  const changedIdx = fieldsets.indexOf(input.closest('fieldset'));
  const selected = fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
  const matches = (v, i) => v[`option${i + 1}`] === selected[i];

  // exact combination is available: nothing to fix
  if (variants.some((v) => v.available && selected.every((_, i) => matches(v, i)))) return;

  // keep the clicked option, pick the available variant sharing the most other options
  const candidates = variants.filter((v) => v.available && matches(v, changedIdx));
  if (!candidates.length) return;
  const score = (v) => selected.filter((_, i) => i !== changedIdx && matches(v, i)).length;
  const best = candidates.sort((a, b) => score(b) - score(a))[0];

  fieldsets.forEach((fs, i) => {
    if (i === changedIdx) return;
    const value = best[`option${i + 1}`];
    fs.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = r.value === value));
    const label = fs.querySelector('[data-selected-value], [data-selected-swatch-value]');
    if (label) label.textContent = value;
  });
}

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
